// -------------------------------------------------------------
// DYNAMIC META PIXEL & ANALYTICS TRACKER FOR SATALA DERMATECH
// -------------------------------------------------------------

export const getPixelConfig = () => {
  try {
    const saved = localStorage.getItem('satala_pixel_config');
    if (saved) {
      const parsed = JSON.parse(saved);
      return {
        ...parsed,
        googleTagId: parsed.googleTagId || 'AW-18374178048'
      };
    }
  } catch (e) {
    console.error('Error reading pixel config:', e);
  }
  return {
    metaPixelId: '700619659717241',
    tikTokPixelId: '',
    googleTagId: 'AW-18374178048'
  };
};

export const savePixelConfig = (config) => {
  try {
    localStorage.setItem('satala_pixel_config', JSON.stringify(config));
    initMetaPixel(config.metaPixelId);
    if (config.googleTagId) {
      initGoogleTag(config.googleTagId);
    }
  } catch (e) {
    console.error('Error saving pixel config:', e);
  }
};

export const initGoogleTag = (tagId = 'AW-18374178048') => {
  if (!tagId || typeof window === 'undefined') return;

  if (!document.getElementById('google-gtag-script')) {
    const script = document.createElement('script');
    script.id = 'google-gtag-script';
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${tagId}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag(){ window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', tagId);

    // Global helper function for Google Ads Click Conversions
    window.gtag_report_conversion = function(url) {
      var callback = function () {
        if (typeof(url) != 'undefined') {
          window.location = url;
        }
      };
      gtag('event', 'conversion', {
          'send_to': 'AW-18374178048/EpSXCL3cgd0cEIDqvrlE',
          'value': 1.0,
          'currency': 'IDR',
          'event_callback': callback
      });
      return false;
    };
  }
};

export const trackGoogleConversion = (sendTo = 'AW-18374178048/EpSXCL3cgd0cEIDqvrlE') => {
  if (typeof window !== 'undefined') {
    if (!window.gtag) {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function(){ window.dataLayer.push(arguments); };
    }
    try {
      window.gtag('event', 'conversion', {
        'send_to': sendTo,
        'value': 1.0,
        'currency': 'IDR'
      });
      window.gtag('event', 'conversion', {
        'send_to': 'AW-18374178048/EpEKCIJcg6IeEIEQur1d',
        'value': 1.0,
        'currency': 'IDR'
      });
      window.gtag('event', 'generate_lead', {
        'value': 1,
        'currency': 'IDR'
      });
      console.log(`[Google Tag] Tracked Click conversion for ID: ${sendTo}`);
    } catch(e) {}
  }
};

export const initMetaPixel = (pixelId) => {
  if (!pixelId || typeof window === 'undefined') return;

  // Cek apakah Meta Pixel script sudah terpasang
  if (window.fbq) {
    try {
      window.fbq('init', pixelId);
      window.fbq('track', 'PageView');
    } catch (e) {
      console.log('FB Pixel track PageView', e);
    }
    return;
  }

  // Inject Meta Pixel Standard Snippet
  /* eslint-disable */
  (function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)})(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */

  try {
    window.fbq('init', pixelId);
    window.fbq('track', 'PageView');
    console.log(`[Meta Pixel] Initialized successfully with ID: ${pixelId}`);
  } catch (err) {
    console.error('Error init FB Pixel:', err);
  }
};

export const trackMetaLead = (leadData = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    try {
      window.fbq('track', 'Lead', {
        content_name: 'Maklon Consultation WA',
        content_category: leadData.source || 'Direct',
        value: 1.00,
        currency: 'IDR'
      });
      console.log('[Meta Pixel] Tracked Lead Event');
    } catch (e) {
      console.error('Error tracking FB Lead:', e);
    }
  }
};
